import { createFileRoute } from '@tanstack/react-router'
import { BroadcastModeRedirect } from '@/features/chat'

export const Route = createFileRoute('/chat/broadcasts/')({
  component: () => <BroadcastModeRedirect mode="list" />,
  staticData: { authorize: true },
})
